import { StartNodeBlockContent } from './Content';
import { StartFormFields } from './FormFields';
import { START_DOCUMENTATION_MARKDOWN } from './documentation';
import { StartBlockConfigSchema } from './schema';
import { defaultStartNodeLabelPrefix, getDefaultStartNodeConfig } from './utils';
import { ProducedType } from '../../../types';
import { type BlockConfigProps } from '../../types';

export const startConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'source' }],
  defaultLabelPrefix: defaultStartNodeLabelPrefix,
  defaultConfig: getDefaultStartNodeConfig(),
  configFields: {
    schema: StartBlockConfigSchema,
    FormFields: StartFormFields,
  },
  BlockContent: StartNodeBlockContent,
  documentationMarkdown: START_DOCUMENTATION_MARKDOWN,
  returnType: ProducedType.Start,
  mockDataType: 'none',
};
